import { styled } from "@linaria/react";
import React from "react";
import t from "../../../../../../i18n";
import ButtonIconV2 from "@ui/ButtonIconV2";
import { PencilLine } from "@ui/IconV2/react";

interface P {
  className?: string;
  onEdit: () => void;
}

const ActionIcons = styled.div`
  display: flex;
  align-items: center;
`;

const Actions = ({ className, onEdit }: P) => (
  <ActionIcons className={className} data-cy="project-action-icons">
    <ButtonIconV2 title={t("projects.actions.edit")} data-cy="edit-project" onClick={onEdit}>
      <PencilLine size="m" />
    </ButtonIconV2>
  </ActionIcons>
);
export default React.memo(Actions);
